import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'attendance/'

const initialState = {
    attData: [],
    dateWiseAtt: [],
    monthlyAttendance: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addManualAttendance = createAsyncThunk('att/ma', async (attData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'manualAttendance', attData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const lookupBulkAttendanceEmployees = createAsyncThunk('att/bulkLookup', async (pins, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'bulkEmployeeLookup', { pins })
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
export const addBulkManualAttendance = createAsyncThunk('att/bulkManual', async (attendanceData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'bulkManualAttendance', attendanceData)
        return result.data
    } catch (error) {
        // Preserve the server response object so the screen can show the
        // missing-shift employee list in its modal.
        return thunkAPI.rejectWithValue(error.response?.data || {
            error: error.message || error.toString()
        })
    }
})

export const getDailyAttendance = createAsyncThunk('att/gda', async (attData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getDailyAttendance', attData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getEmployeeMonthlyAttendance = createAsyncThunk('att/monthly', async ({ empID, month, year }, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}monthly/${empID}?month=${month || ''}&year=${year || ''}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateAttendance = createAsyncThunk('att/update', async ({ id, data }, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}${id}`, data)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteAttendance = createAsyncThunk('att/delete', async ({ id, data }, thunkAPI) => {
    try {
        console.log('Deleting attendance with data:', { id, data });
        const result = await axios.delete(`${API_URL}${id}`, { data })
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const menuSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.attData = []
            state.dateWiseAtt = []
            state.monthlyAttendance = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        },
        clearSuccess: (state) => {
            state.isSuccess = false
        },
        clearError: (state) => {
            state.isError = false
            state.message = ""
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDailyAttendance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDailyAttendance.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.dateWiseAtt = action.payload
            })
            .addCase(getDailyAttendance.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.dateWiseAtt = []
            })
            .addCase(getEmployeeMonthlyAttendance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getEmployeeMonthlyAttendance.fulfilled, (state, action) => {
                state.isLoading = false
                state.monthlyAttendance = action.payload
            })
            .addCase(getEmployeeMonthlyAttendance.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.monthlyAttendance = []
            })
            .addCase(updateAttendance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateAttendance.fulfilled, (state) => {
                state.isLoading = false
                state.isSuccess = true
            })
            .addCase(updateAttendance.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(deleteAttendance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteAttendance.fulfilled, (state) => {
                state.isLoading = false
                state.isSuccess = true
            })
            .addCase(deleteAttendance.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset, clearSuccess, clearError } = menuSlice.actions

export default menuSlice.reducer
